<div class="w-full">
    <p-table #dt1 [value]="user_list" sortField="id" [sortOrder]="1" [rows]="10" [paginator]="true" [rowsPerPageOptions]="[10, 25, 50]" [globalFilterFields]="['id', 'externalId', 'firstName', 'lastName', 'fullName']" editMode="row" datakey="id" (onFilter)="tableChanged()" (onEditInit)="prevRowState($event)" (onEditComplete)="userEdited($event)" (onSort)="tableChanged()">
        <ng-template pTemplate="caption"> 
            <div class="flex align-items-center justify-content-between"> 
                <div class="flex align-items-center gap-2">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="onGlobalFilter(dt1, $event)" placeholder="Search"/>
                    </span>
                    <p-button icon="pi pi-sync" text (onClick)="refreshTable()"/>
                </div>
                <div class="flex align-items-center justify-content-between">
                    <p-button label="Insert" (click)="insertNewUsers()" [outlined]="true" [disabled]="insertable_users.size == 0" [style.opacity]="insertable_users.size > 0 ? '1' : '0.5'" class="insert-button"/>
                    <p-button icon="pi pi-plus" text (onClick)="addBlankUser()"/>
                </div>
            </div>
            <p-messages *ngIf="max_new_users_reached" severity="info" [(value)]="messages" [closable]="false"/>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="id" style="width:20%">Id <p-sortIcon field="id"/> </th> 
                <th style="width:20%">External Id </th>
                <th pSortableColumn="firstName" style="width:20%">First Name <p-sortIcon field="firstName"/> </th>
                <th pSortableColumn="lastName" style="width:20%">Last Name <p-sortIcon field="lastName"/> </th>
                <th pSortableColumn="active" style="width:20%">Active <p-sortIcon field="active"/> </th>
                <th style="width:20%"></th>
            </tr>
            <tr *ngFor="let line of new_users; let i = index">
                <td style="padding: 12px;">New User</td>
                <td style="padding: 3px;">
                    <input type="text" pInputText [(ngModel)]="line.externalId" placeholder="External Id" (ngModelChange)="checkNewUser(i)" class="w-full"/>
                    <div *ngIf="!validateField(line.externalId, line.id)" style="color: red; margin-top: 2px;">
                        External Id already exists
                    </div>
                </td>
                <td style="padding: 3px;">
                    <input type="text" pInputText [(ngModel)]="line.firstName" placeholder="First Name" (ngModelChange)="checkNewUser(i)" class="w-full"/>
                </td>
                <td style="padding: 3px;">
                    <input type="text" pInputText [(ngModel)]="line.lastName" placeholder="Last Name" (ngModelChange)="checkNewUser(i)" class="w-full"/>
                </td>
                <td style="padding: 15px;">
                    <p-checkbox [(ngModel)]="line.active" [binary]="true" inputId="binaryInsert" (onChange)="checkNewUser(i)"/>
                </td>
                <td>
                    <div class="flex align-items-center justify-content-between" style="padding: 13px;">
                        <p-button label="Delete" (click)="confirmDelete($event, -1, i)" severity="danger" [outlined]="true"/> 
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-line let-editing="editing" let-rowIndex="rowIndex">
                <tr>
                    <td>
                        {{line.id}}
                    </td> 
                    <td [pEditableColumn]="line.externalId" pEditableColumnField="externalId" [pEditableColumnRowIndex]="rowIndex">
                        <ng-container *ngIf="!line.externalId; else editableExternalId">
                            <input type="text" pInputText [(ngModel)]="line.externalId" placeholder="External Id" class="w-full"/>
                        </ng-container>
                        <ng-template #editableExternalId>
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <input type="text" pInputText [(ngModel)]="line.externalId" placeholder="External Id" class="w-full"/>
                                </ng-template>
                                <ng-template pTemplate="output">
                                    {{line.externalId}}
                                </ng-template>
                            </p-cellEditor>
                        </ng-template>
                        <div *ngIf="!validateField(line.externalId, line.id)" style="color: red; margin-top: 2px;">
                            External Id already exists
                        </div>
                    </td>        
                    <td [pEditableColumn]="line.firstName" pEditableColumnField="firstName" [pEditableColumnRowIndex]="rowIndex">
                        <ng-container *ngIf="!line.firstName; else editableFirstName">
                            <input type="text" pInputText [(ngModel)]="line.firstName" placeholder="First Name" class="w-full" [disabled]="!validateField(line.externalId, line.id)" [style.opacity]="validateField(line.externalId, line.id) ? '1' : '0.5'"/>
                        </ng-container>
                        <ng-template #editableFirstName> 
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <input type="text" pInputText [(ngModel)]="line.firstName" placeholder="First Name" class="w-full" [disabled]="!validateField(line.externalId, line.id)" [style.opacity]="validateField(line.externalId, line.id) ? '1' : '0.5'"/>
                                </ng-template>
                                <ng-template pTemplate="output">
                                    {{line.firstName}}
                                </ng-template>
                            </p-cellEditor>
                        </ng-template>
                    </td>
                    <td [pEditableColumn]="line.lastName" pEditableColumnField="lastName" [pEditableColumnRowIndex]="rowIndex">
                        <ng-container *ngIf="!line.lastName; else editableLastName">
                            <input type="text" pInputText [(ngModel)]="line.lastName" placeholder="Last Name" class="w-full" [disabled]="!validateField(line.externalId, line.id)" [style.opacity]="validateField(line.externalId, line.id) ? '1' : '0.5'"/>
                        </ng-container>
                        <ng-template #editableLastName>
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <input type="text" pInputText [(ngModel)]="line.lastName" placeholder="Last Name" class="w-full" [disabled]="!validateField(line.externalId, line.id)" [style.opacity]="validateField(line.externalId, line.id) ? '1' : '0.5'"/>
                                </ng-template>
                                <ng-template pTemplate="output">
                                    {{line.lastName}}
                                </ng-template>
                            </p-cellEditor>
                        </ng-template>
                    </td>
                    <td>
                        <p-checkbox [(ngModel)]="line.active" [binary]="true" inputId="binary" (onChange)="statusChanged($event, line.id)" [disabled]="!validateField(line.externalId, line.id)" [style.opacity]="validateField(line.externalId, line.id) ? '1' : '0.5'"/>
                    </td> 
                    <td>
                        <div class="flex justify-content-between">
                            <span style="display: inline-flex; align-items: center; white-space: nowrap" *ngIf="getEncounterCount(line.id) > 0">{{getEncounterCount(line.id)}} encounters</span>
                            <p-toast />
                            <p-confirmPopup />
                            <p-button *ngIf="line.id != current_user_id && getEncounterCount(line.id) == 0 && encounterCountsLoaded" (click)="confirmDelete($event, line.id, -1)" label="Delete" severity="danger" [outlined]="true"/> 
                        </div>
                    </td>
                </tr>
            
        </ng-template>
    </p-table> 
</div>